import { useState } from 'react';

import { useSelector } from 'react-redux';

import { selectCartTotal } from '../../store/cart/cart.selector';

import { paymentHandler } from '../../components/payment-form/payment-form';

import { getUserDetailsFromUserDatabase } from '../../utils/firebase/firebase.utils';

import { selectCurrentUser } from '../../store/user/user.selector';

import { useEffect } from 'react';

import GrowSpinner from '../../components/Spinner/grow-spinner/grow-spinner.component';
import FooterNew from '../../components/Footer/section-footer';
import './checkout-billing-address.styles.css';

const CheckoutBillingAddress = () => {
  const [showGrowSpinner, setGrowSpinner] = useState(false);

  const amount = useSelector(selectCartTotal);

  const currentUser = useSelector(selectCurrentUser);

  const defaultData = {
    fullname: '',
    email: '',
    address: '',
    pincode: '',
    mobile: '',
  };
  const [formFields, setFormFields] = useState(defaultData);

  const { fullname, email, address, pincode, mobile } = formFields;

  useEffect(() => {
    if (currentUser) {
      const userData = async () => {
        const getUserDetails = await getUserDetailsFromUserDatabase(
          currentUser.id
        );
        const { firstname, lastname, email } = getUserDetails;
        if (firstname === undefined) {
          var fullname = '';
        } else {
          fullname = firstname + ' ' + lastname;
        }

        setFormFields({ ...formFields, fullname: fullname, email: email });
      };
      userData();
    }
  }, [currentUser]);

  const handleFormField = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };

  const billingSubmitHandler = async (e) => {
    e.preventDefault();
    const checkoutBtn = document.querySelector('.checkout__btn');
    checkoutBtn.textContent = 'Loading...';
    checkoutBtn.disabled = true;

    // setGrowSpinner(true);
    const response = await paymentHandler(formFields, amount);
    if (response) {
      checkoutBtn.textContent = 'Proceed to Payment';
      checkoutBtn.disabled = false;
      setFormFields(defaultData);
    }
  };

  return (
    <>
      <div className="section">
        <div className="container">
          <h2 className="heading-secondary">Billing Details:</h2>
          <form onSubmit={billingSubmitHandler}>
            <div className="cta-form margin-bottom-m">
              <div className="checkout__billing-input">
                <label for="name">Name</label>
                <input
                  type="text"
                  onChange={handleFormField}
                  id="name"
                  placeholder="John Doe"
                  name="fullname"
                  value={fullname}
                  required
                />
              </div>
              <div className="checkout__billing-input">
                <label for="email">Email</label>
                <input
                  type="email"
                  onChange={handleFormField}
                  id="email"
                  placeholder="john@example.com"
                  name="email"
                  value={email}
                  required
                />
              </div>
              <div className="checkout__billing-input">
                <label for="address">Address</label>
                <input
                  type="textarea"
                  onChange={handleFormField}
                  id="address"
                  placeholder="Address"
                  name="address"
                  value={address}
                  required
                />
              </div>
              <div className="checkout__billing-input">
                <label for="pincode">Pin Code</label>
                <input
                  type="number"
                  onChange={handleFormField}
                  id="number"
                  placeholder="110001"
                  name="pincode"
                  value={pincode}
                  required
                />
              </div>

              <div className="checkout__billing-input">
                <label for="mobile">Mobile</label>
                <input
                  type="tel"
                  onChange={handleFormField}
                  id="mobile"
                  placeholder="mobile"
                  name="mobile"
                  value={mobile}
                  required
                />
              </div>
            </div>
            {showGrowSpinner ? (
              <GrowSpinner />
            ) : (
              <button type="submit" className="checkout__btn">
                Proceed to Payment
              </button>
            )}
          </form>
        </div>
      </div>
      <FooterNew />
    </>
  );
};

export default CheckoutBillingAddress;
